export const SEPARACION_X = 230;
export const SEPARACION_Y = 130;

export const LADOS_CONECTOR = ["top", "right", "bottom", "left"];

export const CONECTORES_VALIDOS = new Set(LADOS_CONECTOR.flatMap((lado) => [`${lado}-source`, `${lado}-target`]));

export const idDestino = (transicion) => transicion.etapaDestinoId?._id || transicion.etapaDestinoId;

export const claveFlecha = (origenId, destinoId, indice) => `${origenId}|${destinoId}|${indice}`;

// Nivel = distancia (en transiciones) desde la etapa inicial. Las que ninguna transición alcanza
// quedan en una columna aparte al final, igual que en "Ordenar por transición".
export const calcularNiveles = (etapas) => {
  const nivelPorId = new Map();
  const porId = new Map(etapas.map((e) => [e._id, e]));
  const inicial = etapas.find((e) => e.esInicial);
  const cola = inicial ? [[inicial._id, 0]] : [];

  while (cola.length > 0) {
    const [id, nivel] = cola.shift();
    if (nivelPorId.has(id)) continue;
    nivelPorId.set(id, nivel);
    (porId.get(id)?.transiciones || []).forEach((t) => {
      const destinoId = idDestino(t);
      if (destinoId && !nivelPorId.has(destinoId)) cola.push([destinoId, nivel + 1]);
    });
  }

  const maxNivel = Math.max(0, ...nivelPorId.values());
  etapas.forEach((e) => {
    if (!nivelPorId.has(e._id)) nivelPorId.set(e._id, maxNivel + 1);
  });
  return nivelPorId;
};

export const posicionesAutomaticas = (etapas, nivelPorId) => {
  const contadorPorNivel = new Map();
  const posiciones = new Map();
  etapas.forEach((etapa) => {
    const nivel = nivelPorId.get(etapa._id) || 0;
    const indice = contadorPorNivel.get(nivel) || 0;
    contadorPorNivel.set(nivel, indice + 1);
    posiciones.set(etapa._id, { x: nivel * SEPARACION_X, y: indice * SEPARACION_Y });
  });
  return posiciones;
};

const tienePosicion = (etapa) => Number.isFinite(etapa.diagrama?.x) && Number.isFinite(etapa.diagrama?.y);

export const calcularPosiciones = (etapas, nivelPorId, posicionesPrevias = new Map()) => {
  const acomodadas = etapas.filter((e) => posicionesPrevias.has(e._id) || tienePosicion(e));
  if (acomodadas.length === 0) return posicionesAutomaticas(etapas, nivelPorId);

  const posiciones = new Map();
  acomodadas.forEach((e) => posiciones.set(e._id, posicionesPrevias.get(e._id) || { x: e.diagrama.x, y: e.diagrama.y }));

  const xLibre = Math.max(...[...posiciones.values()].map((p) => p.x)) + SEPARACION_X;
  let indiceLibre = 0;
  etapas.forEach((e) => {
    if (posiciones.has(e._id)) return;
    posiciones.set(e._id, { x: xLibre, y: indiceLibre * SEPARACION_Y });
    indiceLibre += 1;
  });
  return posiciones;
};

export const flechasGuardadas = (etapas) => {
  const flechas = new Map();
  etapas.forEach((etapa) => {
    (etapa.diagrama?.flechas || []).forEach((f) => {
      flechas.set(claveFlecha(etapa._id, f.etapaDestinoId, f.indice || 0), {
        puntos: f.puntos || [],
        etiquetaDx: f.etiquetaDx || 0,
        etiquetaDy: f.etiquetaDy || 0,
        ...(CONECTORES_VALIDOS.has(f.sourceHandle) && { sourceHandle: f.sourceHandle }),
        ...(CONECTORES_VALIDOS.has(f.targetHandle) && { targetHandle: f.targetHandle }),
      });
    });
  });
  return flechas;
};

export const transicionesConIndice = (etapa) => {
  const vecesPorDestino = new Map();
  return (etapa.transiciones || [])
    .filter((t) => idDestino(t))
    .map((t) => {
      const destinoId = idDestino(t);
      const indice = vecesPorDestino.get(destinoId) || 0;
      vecesPorDestino.set(destinoId, indice + 1);
      return { transicion: t, destinoId, indice };
    });
};
